import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import HeartFilledSvg from "@ant-design/icons-svg/es/asn/HeartFilled";
import AntdIcon from "../components/AntdIcon";
var HeartFilled = function HeartFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HeartFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  HeartFilled.displayName = 'HeartFilled';
}
export default /*#__PURE__*/React.forwardRef(HeartFilled);